import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { GroupPortalDataService } from '../services';
import { GlobalDomOpsService } from '@acepteam/globalspack';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupPortalResolve implements Resolve<any>{
  
  constructor(private service: GroupPortalDataService, private globaldomops: GlobalDomOpsService) {}

  resolve(route: ActivatedRouteSnapshot) {   
    return this.service.GetGroupPortalData().pipe(first()) //take(1) // To make the observable complete after the first emission;
  }


}
